import { render, staticRenderFns } from "./BrandValue.vue?vue&type=template&id=6306e494&scoped=true"
import script from "./BrandValue.vue?vue&type=script&lang=js"
export * from "./BrandValue.vue?vue&type=script&lang=js"
import style0 from "./BrandValue.vue?vue&type=style&index=0&id=6306e494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6306e494",
  null
  
)

export default component.exports